import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  CurrTab: "",
  Pages: {},
};
const HistorySlice = createSlice({
  name: "History",
  initialState,
  reducers: {
    SetTab: (state, action) => {
      state.CurrTab = action.payload;
    },
    UpdateHistory: (state, action) => {
      const { Page, Key, Value, CurrTab } = action.payload;
      if (typeof Key === "object") {
        state.Pages[Page] = {
          ...state.Pages[Page],
          ...Key,
        };
        return;
      }
      state.Pages[Page] = {
        ...state.Pages[Page],
        [Key]: Value,
      };
    },
    ResetHistory: (state, action) => {
      if (!action.payload) return;
      delete state.Pages[action.payload];
      state.CurrTab = "";
    },
  },
});

export default HistorySlice.reducer;
export const { SetTab,UpdateHistory, ResetHistory } = HistorySlice.actions;
